<script setup>
import { cn } from "@/lib/utils";

const props = defineProps({
  class: { type: null, required: false },
});
</script>

<template>
  <div
    :class="
      cn(
        'vf-flex vf-flex-col vf-gap-y-1.5 vf-text-center sm:vf-text-left',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
